// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Exception from "../Effect.Exception/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var $$void = /* #__PURE__ */ Data_Functor["void"](Effect.functorEffect);
var bind = /* #__PURE__ */ Control_Bind.bind(Effect_Aff.bindAff);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Aff.monadEffectAff);
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var genericShowSum = /* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "NotRequested";
    }
}));
var genericShowSum1 = /* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "Loading";
    }
}));
var LoadedIsSymbol = {
    reflectSymbol: function () {
        return "Loaded";
    }
};
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorEvent);
var map1 = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var NotRequested = /* #__PURE__ */ (function () {
    function NotRequested() {

    };
    NotRequested.value = new NotRequested();
    return NotRequested;
})();
var Loading = /* #__PURE__ */ (function () {
    function Loading() {

    };
    Loading.value = new Loading();
    return Loading;
})();
var Loaded = /* #__PURE__ */ (function () {
    function Loaded(value0) {
        this.value0 = value0;
    };
    Loaded.create = function (value0) {
        return new Loaded(value0);
    };
    return Loaded;
})();
var startAff = function (dictMonadFRP) {
    var MonadCleanup1 = dictMonadFRP.MonadCleanup1();
    var bind2 = Control_Bind.bind((MonadCleanup1.Monad0()).Bind1());
    var liftEffect1 = Effect_Class.liftEffect(dictMonadFRP.MonadEffect0());
    var onCleanup = Control_Monad_Cleanup.onCleanup(MonadCleanup1);
    return function (action) {
        return bind2(liftEffect1(Effect_Aff.launchAff(action)))(function (fiber) {
            return onCleanup(Effect_Aff.launchAff_(Effect_Aff.killFiber(Effect_Exception.error("Cancelled"))(fiber)));
        });
    };
};
var performEvent = function (dictMonadFRP) {
    var MonadCleanup1 = dictMonadFRP.MonadCleanup1();
    var Monad0 = MonadCleanup1.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind2 = Control_Bind.bind(Bind1);
    var MonadEffect0 = dictMonadFRP.MonadEffect0();
    var newEvent = Specular_FRP_Base.newEvent(MonadEffect0);
    var discard2 = discard(Bind1);
    var subscribeEvent_ = Specular_FRP_Base.subscribeEvent_(MonadEffect0)(MonadCleanup1);
    var pure1 = Control_Applicative.pure(Monad0.Applicative0());
    return function (event) {
        return bind2(newEvent)(function (output) {
            return discard2(subscribeEvent_(function (action) {
                return $$void(Effect_Aff.launchAff(bind(action)(function (x) {
                    return liftEffect(output.fire(x));
                })));
            })(event))(function () {
                return pure1(output.event);
            });
        });
    };
};
var genericRequestState = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return NotRequested.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return Loading.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return new Loaded(x.value0.value0);
        };
        throw new Error("Failed pattern match at Specular.FRP.Async (line 34, column 1 - line 34, column 66): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof NotRequested) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Loading) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Loaded) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
        };
        throw new Error("Failed pattern match at Specular.FRP.Async (line 34, column 1 - line 34, column 66): " + [ x.constructor.name ]);
    }
};
var genericShow = /* #__PURE__ */ Data_Show_Generic.genericShow(genericRequestState);
var showRequestState = function (dictShow) {
    return {
        show: genericShow(genericShowSum(genericShowSum1(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow))(LoadedIsSymbol))))
    };
};
var functorRequestState = {
    map: function (f) {
        return function (m) {
            if (m instanceof NotRequested) {
                return NotRequested.value;
            };
            if (m instanceof Loading) {
                return Loading.value;
            };
            if (m instanceof Loaded) {
                return new Loaded(f(m.value0));
            };
            throw new Error("Failed pattern match at Specular.FRP.Async (line 0, column 0 - line 0, column 0): " + [ m.constructor.name ]);
        };
    }
};
var fromLoaded = function (v) {
    if (v instanceof Loaded) {
        return new Data_Maybe.Just(v.value0);
    };
    return Data_Maybe.Nothing.value;
};
var eqRequestState = function (dictEq) {
    var eq = Data_Eq.eq(dictEq);
    return {
        eq: function (x) {
            return function (y) {
                if (x instanceof NotRequested && y instanceof NotRequested) {
                    return true;
                };
                if (x instanceof Loading && y instanceof Loading) {
                    return true;
                };
                if (x instanceof Loaded && y instanceof Loaded) {
                    return eq(x.value0)(y.value0);
                };
                return false;
            };
        }
    };
};
var asyncRequestMaybe = function (dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind2 = Control_Bind.bind(Bind1);
    var newEvent = Specular_FRP_Base.newEvent(dictMonadEffect);
    var liftEffect1 = Effect_Class.liftEffect(dictMonadEffect);
    var pull = Specular_FRP_Base.pull(dictMonadEffect);
    var discard2 = discard(Bind1);
    var pure1 = Control_Applicative.pure(Monad0.Applicative0());
    return function (dictMonadFRP) {
        var holdDyn = Specular_FRP_Base.holdDyn(dictMonadFRP);
        var subscribeDyn_ = Specular_FRP_Base.subscribeDyn_(dictMonadFRP);
        return function (dquery) {
            return bind2(newEvent)(function (loadStateChanged) {
                return bind2(liftEffect1(Effect_Ref["new"](pure(Data_Unit.unit))))(function (cancelCurrentRef) {
                    var runAndUpdateResult = function (query) {
                        return bind(query)(function (value) {
                            return liftEffect(loadStateChanged.fire(new Loaded(value)));
                        });
                    };
                    var update = function (m_query) {
                        return function __do() {
                            var cancelCurrent = Effect_Ref.read(cancelCurrentRef)();
                            cancelCurrent();
                            if (m_query instanceof Data_Maybe.Nothing) {
                                return Effect_Ref.write(pure(Data_Unit.unit))(cancelCurrentRef)();
                            };
                            if (m_query instanceof Data_Maybe.Just) {
                                var fiber = Effect_Aff.launchAff(runAndUpdateResult(m_query.value0))();
                                return Effect_Ref.write(Effect_Aff.launchAff_(Effect_Aff.killFiber(Effect_Exception.error("Cancelled"))(fiber)))(cancelCurrentRef)();
                            };
                            throw new Error("Failed pattern match at Specular.FRP.Async (line 69, column 7 - line 74, column 84): " + [ m_query.constructor.name ]);
                        };
                    };
                    var initialStatus = function (v) {
                        if (v instanceof Data_Maybe.Just) {
                            return Loading.value;
                        };
                        if (v instanceof Data_Maybe.Nothing) {
                            return NotRequested.value;
                        };
                        throw new Error("Failed pattern match at Specular.FRP.Async (line 82, column 5 - line 82, column 37): " + [ v.constructor.name ]);
                    };
                    return bind2(pull(Specular_FRP_Base.readBehavior(Specular_FRP_Base.current(dquery))))(function (initialValue) {
                        return bind2(holdDyn(initialStatus(initialValue))(Specular_FRP_Base.leftmost([ map(initialStatus)(Specular_FRP_Base.changed(dquery)), loadStateChanged.event ])))(function (dyn) {
                            return discard2(subscribeDyn_(update)(dquery))(function () {
                                return pure1(dyn);
                            });
                        });
                    });
                });
            });
        };
    };
};
var asyncRequest = function (dictMonadEffect) {
    var asyncRequestMaybe1 = asyncRequestMaybe(dictMonadEffect);
    return function (dictMonadFRP) {
        var asyncRequestMaybe2 = asyncRequestMaybe1(dictMonadFRP);
        return function (dquery) {
            return asyncRequestMaybe2(map1(Data_Maybe.Just.create)(dquery));
        };
    };
};
export {
    startAff,
    NotRequested,
    Loading,
    Loaded,
    fromLoaded,
    asyncRequestMaybe,
    asyncRequest,
    performEvent,
    eqRequestState,
    genericRequestState,
    functorRequestState,
    showRequestState
};
